import 'typeface-roboto/index.css';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import Vue from 'vue'
import Vuetify from 'vuetify/lib'

import 'vuetify/src/stylus/app.styl'
import * as directives from 'vuetify/es5/directives'

export const v = Vue.use(Vuetify, {
  iconfont: 'md',
  directives,
  options: {
    customProperties: true
  },
})


